const filtersForm = document.querySelector( '#filters-form' );
const filters = document.querySelectorAll( '.filter' );

filters.forEach( function ( filter ) {

  filter.addEventListener( 'change', function ( event ) {

    filter.classList.add( 'is-submitting' );

    filtersForm.submit();

  } );

} );
